import { render } from "./AppPassword.vue?vue&type=template&id=369c7d62"
import script from "./AppPassword.vue?vue&type=script&lang=ts"
export * from "./AppPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script